
















import { isAfter, isBefore, isSameDay, format } from 'date-fns';

export default {
  name: 'TermsField',
  props: {
    original: {
      default: null,
    },
    value: {
      default: null,
    },
    default: {
      default: null,
    },
    copy_rule: {
      default: null,
    },
    noCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNegotiation: true,
      showRightSide: true,
      isNegotiating: true,
    };
  },
  inject: ['addField', 'removeField'],
  mounted() {
    if (!this.noCount) {
      this.addField(this);
    }
  },
  destroyed() {
    if (!this.noCount) {
      this.removeField(this);
    }
  },
  methods: {
    reset() {
      this.mutableValue = this.default;
    },
    copy() {
      if (this.copy_rule && typeof this.copy_rule === 'function') {
        return this.copy_rule(this.original, this.mutableValue);
      } else if (typeof this.copy_rule === 'string') {
        this.presetCopy();
      } else {
        this.mutableValue = this.original;
      }
    },
    presetCopy() {
      if (this.copy_rule === 'first') {
        this.mutableValue = this.original.first();
      } else if (this.copy_rule === 'last') {
        this.mutableValue = this.original.last();
      } else if (this.copy_rule === 'all') {
        this.mutableValue = this.original;
      }
    },
  },
  computed: {
    mutableValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
